import RequestStatus from "./RequestStatus";
import {BulkProductDataQueryStartAction} from "src/actions/BulkProductSearchAction";

export interface ProductInfo {
    readonly encryptedMarketplaceId?: string;
    readonly asin: string;
    readonly isAsinLimits?: boolean;
    readonly imageUrl?: string;
    readonly thumbStringUrl?: string;
    readonly originalUrl?: string; // url from pas w/o rending information
    readonly gl: string;
    readonly productGroup?: string;
    readonly subCategory?: string;
    readonly tRexId?: string;
    readonly isWhiteGloveRequired?: boolean;
    readonly specialDeliveryRequirement?: string;
    readonly title: string;
    readonly binding?: string;
    readonly weightUnit?: string;
    readonly weightUnitStringId?: string; // Localized string
    readonly weight?: number;

    readonly dimensionUnit?: string;
    readonly dimensionUnitStringId?: string; // Localized string
    readonly width?: number;
    readonly length?: number;
    readonly height?: number;
    readonly currency?: string;
    readonly price?: number;
    readonly merchantSku?: string;
    readonly fnsku?: string;
    readonly link: string;
    readonly isAfn?: boolean;

    readonly salesRank?: number;
    readonly salesRankContextName?: string;
    readonly customerReviewsCount?: number;
    readonly customerReviewsRating?: string;
    readonly customerReviewsRatingfullStarCount?: number;
    readonly customerReviewsRatingValue?: number;

    readonly offerCount?: number;

    readonly winOfferFulfillerName?: string;
    readonly winOfferMerchantName?: string;
    readonly winOfferPriceAmount?: number;
    readonly winOfferPriceCurrencyCode?: string;
    readonly winOfferShippingAmount?: number;
    readonly winOfferCondition?: string;

    readonly programInputMap?: Map<string, ProgramInput>;
    readonly isNonPeakSelected?: boolean;
}

export interface ProgramInput {
    readonly averageInventoryUnitsStored?: number;
    readonly estimatedMonthlyUnitsSold?: number;
    readonly costOfGoodsSold?: number;
    readonly miscellaneousCost?: number;
    readonly estimatedSales?: number;
    readonly sendToAmazon?: number;
    readonly shippingCharge?: number;
    readonly fulfillCost?: number;
    readonly monthlyStorageCostPerUnit?: number;

    readonly marketplace?: string;
    readonly inventoryPlace?: string;
    readonly cee?: boolean;

    readonly isPlacement?: boolean;
    readonly isOpaqueBagging?: boolean;
    readonly isTape?: boolean;
    readonly isLabel?: boolean;
    readonly isBagging?: boolean;
    readonly isBubbleWrap?: boolean;
}

export interface ProductInfoResult {
    readonly totalProductCount: number;
    readonly currentPage: number;
    readonly products: Array<ProductInfo>;
}

export interface ProductMatchResult {
    readonly countryCode: string;
    readonly merchantId: string;
    readonly searchKey: string;
    readonly myProducts: ProductInfoResult;
    readonly otherProducts: ProductInfoResult;
}

export interface ProductMatchResponse {
    readonly succeed: boolean;
    readonly data: ProductMatchResult;
}

export interface ProductMatchPageResponse {
    readonly succeed: boolean;
    readonly data: ProductInfoResult;
}

export interface GetProductDataResponse {
    readonly requestStatus: RequestStatus;
    readonly productData: any; // can be ProductMatchResult or null
}

export interface GetProductPageDataResponse {
    readonly requestStatus: RequestStatus;
    readonly productData: any; // can be ProductMatchPageResponse or null
}

export interface GetBulkProductSearchDataResponse {
    readonly requestStatus: RequestStatus;
    readonly productData: any; // can be ProductMatchPageResponse or null
    readonly request?: BulkProductDataQueryStartAction;
}

export interface CurrentCountryCodeResponse {
    readonly succeed: boolean;
    readonly currentCountryCode: string;
}

export interface GetCurrentCountryCodeResponse { // used in reducer
    readonly requestStatus: RequestStatus;
    readonly currentCountryCode: any;
}

export interface SelectedProductResponse { // used in saga
    readonly countryCode: string;
    readonly selectedProduct: any;
}

export interface GetSelectedProductResponse { // used in reducer
    readonly requestStatus: RequestStatus;
    readonly data: any; // can be SelectedProductResponse or null
}

export interface GetIsSelectNew { // used in reducer
    readonly selectNew: any; // can be boolean or null
    readonly oldProduct?: any; // can be ProductInfo or null
}

export interface BulkSearchProductRequest {
    readonly countryCode: string,
    readonly keywords: string,
    readonly pageOffset: number,
    readonly searchType: SearchType,
    readonly filters?: Record<string, string>
    readonly sortOrder?: string,
    readonly sortedColumnId?: string,
}

export interface BulkProducts { // used in reducer
    readonly products: Array<ProductInfo>;
    readonly programs: Array<string>;
    readonly storageSeason: StorageSeason;
}

enum SearchType {
    MERCHANT = "MERCHANT",
    GENERAL = "GENERAL"
}

export enum StorageSeason {
    PEAK = "PEAK",
    NON_PEAK = "NON_PEAK"
}

export enum ServiceAddonFeeChosen {
    isChosen = "x"
}

export default SearchType;
